export default __webpack_public_path__ + "static/media/card-jcb.061a304e.svg";